<template lang="pug">
  .bill-details
    v-container.pa-0(style="max-width:600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .content-layout(v-else)
        v-card
          v-card-title.px-5.white
            v-row(no-gutters align="center")
              v-col.shrink
                v-app-bar-nav-icon.ml-n2.mr-2(small @click="$router.push('/admin/billing/bills')")
                  v-icon(color="primary") mdi-arrow-left
              v-col(v-if="isPaid")
                p.mb-0.h6.basic800--text {{ $t('receipt') }} &#35;{{ getReceiptId() }}
              v-col(v-else)
                p.mb-0.h6.basic800--text {{ $t('invoice') }} &#35;{{ getReceiptId() }}
          v-card-text.pa-0.text-center
            v-container.pt-6
              .paid(v-if="isPaid")
                eva-icon.my-5(name="checkmark-circle-2-outline" :fill="$vuetify.theme.themes[$theme].success" width="50" height="50") 
                p.s1.mb-0.primary500--text {{ $t('amount_paid') }}
                div.h4.primary500--text.text-center {{ bill.total_amount | displayPrice($currency) }}
                h6.s1.primary400--text.text-center {{ bill.paid_at | convertServerDate }}
                v-divider.my-6
              .company-details.text-left.mt-4.px-2
                v-layout
                  div.h6.s1.primary500--text Yezza Tech Sdn Bhd
                div.p2.primary500--text 03-8687 4950
                .address
                  div.p2.primary500--text K-3-01, Conezion, Persiaran IRC3,
                  div.p2.primary500--text IOI Resort City, Putrajaya,
                  div.p2.primary500--text 62502, Wilayah Persekutuan Putrajaya, Malaysia.

              .client-details.text-left.mt-8.px-2
                div.p1.primary500--text Bill to:
                div.s1.primary500--text {{ company.name }}
                div.p2.primary500--text {{ company.phone }}
                .address(v-if="company.address")
                  div.p2.primary500--text {{ company.address.address_1 }},
                  div.p2.primary500--text(v-if="company.address.address_2") {{ company.address.address_2 }},
                  template(v-if="company.address.area")
                    div.p2.primary500--text {{ company.address.postcode }} {{ company.address.area }},
                    div.p2.primary500--text {{ company.address.suburb }}, {{ company.address.city }},
                  div.p2.primary500--text(v-else) {{ company.address.postcode }} {{ company.address.city }},
                  div.p2.primary500--text {{ company.address.state }}, {{ company.address.country }}.
                v-divider.my-6
              v-row.mt-0.mb-3.ml-2.mr-2
                v-col.text-left.pa-0
                  p.mb-1.s1.primary400--text {{ $t('description') }}
                v-col.text-right.pa-0
                  p.mb-1.s1.primary400--text {{ $t('amount') }}

              v-row.mt-0.mb-0.ml-2.mr-2.pa-0(v-for="item in bill.items" :key="item.description")
                v-col.text-left.pa-0.ma-0
                  p.p2.primary500--text.pa-0.mb-2 {{ item.description }}
                v-col.text-right.pa-0.ma-0
                  p.p2.primary500--text.pa-0.mb-2 {{ item.subtotal_amount | displayPrice($currency) }}
              hr.my-5(style="border: 1px dashed #848484; width:100%;")
              v-col.ma-0.pa-0.px-0
                v-row.mt-0.mb-1.ml-2.mr-2
                  v-col.text-left.pa-0
                    p.mb-1.p1.primary400--text {{ $t('subtotal') }}:
                  v-col.text-right.pa-0
                    p.mb-1.p1.primary400--text {{ bill.subtotal_amount | displayPrice($currency) }}
                v-row.mt-0.mb-1.ml-2.mr-2
                  v-col.text-left.pa-0
                    p.mb-1.p1.primary400--text {{ $t('tax') }}:
                  v-col.text-right.pa-0
                    p.mb-1.p1.primary400--text {{ bill.tax_rate }}%
                v-row.mt-0.mb-1.ml-2.mr-2
                  v-col.text-left.pa-0
                    p.mb-1.h6.primary--text {{ $t('total') }}:
                  v-col.text-right.pa-0
                    p.mb-1.h6.primary--text {{ bill.total_amount | displayPrice($currency) }}
                v-row.mt-0.mb-1.ml-2.mr-2(v-if="isPaid")
                v-row.mt-0.mb-1.ml-2.mr-2(v-else)
                  v-col.text-left.pa-0
                    p.p1.danger--text {{ $t('pay_before') }}:
                  v-col.text-right.pa-0
                    p.p1.danger--text {{ bill.due_date | humanizeDate }}
                  v-btn.button-AA-medium.mt-4.white--text(v-if="!isPaid" color="info500" depressed block @click="clickPay") {{ $t('pay_now') }}
              div.text-center.mb-12
                div.label.f1.mb-0.mt-10.primary400--text {{ $t('powered_by_yezza') }}
                div.label.f2.mb-0.mt-0.primary400--text(v-if="isPaid" style="margin-left:2px; font-weight:400;") {{ $t('this_is_computer_generated') }}

</template>

<script>
export default {
  name: 'BillDetails',
  props: ['company', 'id'],
  data () {
    return {
      isFetching: false,
      bill: null
    }
  },
  computed: {
    isPaid () {
      return this.bill.paid
    }
  },
  mounted () {
    this.fetchBill()
  },
  methods: {
    fetchBill() {
      this.isFetching = true
      let url = `/subscription/bills/${this.id}`
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.bill = response.data
      }).catch(() => {})
    },
    getReceiptId () {
      return this.bill.bill_no
    },
    clickPay () {
      this.$router.push(`/admin/billing/bills/${this.bill.id}/pay`)
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  thead {
    background-color: red !important;
  }
}
</style>
